import React from "react";
import api from "./api";
import { getUrlParam, href } from "../../utils/util";
import { post } from "../../utils/request";
import {
    Button,
    List,
    InputItem,
    TextareaItem,
    Icon,
    Toast,
    Modal,
} from "antd-mobile";

import "./index.less";

const alert = Modal.alert;

class VehicleTrialFeedbackForm extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            show: true,
            successStatus: false,
            hasSubmit: false,
            isLoading: true,
            Items: [
                { value: "1", label: "快递快运" },
                { value: "2", label: "三方物流" },
                { value: "3", label: "物流平台" },
                { value: "4", label: "直客" },
                { value: "5", label: "其他" },
            ],
            loading: false,
            businessIndustryType: undefined,
            businessIndustryName: undefined,
            businessDeliveryFrequency: undefined,
            isCargoCompartmentMeet: undefined,
            businessMeet: undefined,
            requiredMileage: undefined,
            isRangeMeet: undefined,
            value7: [],
            charging: {
                fast: undefined,
                slow: undefined,
            },
            reason: undefined,
            hopeRentNum: undefined,
            leaseTerm: undefined,
            recommend: undefined,
        };
    }

    componentDidMount() {}

    componentWillMount() {
        this.check();
    }

    check() {
        post({
            url: api.selectCarProbationFeedbackDetail,
            data: {
                rentalcode: getUrlParam("rentalcode"),
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    //   Toast.info("提交成功", 1);
                    if (res.data) {
                        this.setState({ show: false, hasSubmit: true });
                    } else {
                        this.setState({ show: true, hasSubmit: false });
                    }
                }
            },
            (res) => {
                Toast.info("网络异常", 5);
            }
        );
    }

    onChange = (value) => {
        this.setState({
            businessIndustryType: value,
        });
    };
    onChange1 = (value) => {
        this.setState({
            isCargoCompartmentMeet: value,
        });
    };
    onChange2 = (value) => {
        this.setState({
            isRangeMeet: value,
        });
    };
    onChange3 = (value) => {
        const newValue = this.state.value7;
        const index = newValue.indexOf(value);
        if (index > -1) {
            newValue.splice(index, 1);
        } else {
            newValue.push(value);
        }
        this.setState({
            value7: newValue,
        });
    };
    onChange4 = (value, ele) => {
        const charging = this.state.charging;
        charging[ele] = value;
        this.setState({ charging });
    };
    validate = () => {
        const {
            businessIndustryType,
            businessIndustryName,
            businessDeliveryFrequency,
            isCargoCompartmentMeet,
            businessMeet,
            requiredMileage,
            isRangeMeet,
            value7,
            charging,
            reason,
            hopeRentNum,
            leaseTerm,
            recommend,
        } = this.state;
        if (!businessIndustryType) {
            Toast.info("请选择您的业务所属行业！");
            return false;
        }
        if (businessIndustryType == "5" && !businessIndustryName) {
            Toast.info("请输入您的所属行业！");
            return false;
        }
        if (!businessDeliveryFrequency) {
            Toast.info("请输入业务配送频次！");
            return false;
        }
        if (!isCargoCompartmentMeet) {
            Toast.info("请选择货箱是否满足您的业务需求！");
            return false;
        }
        if (isCargoCompartmentMeet == "0" && !businessMeet) {
            Toast.info("请输入您的货箱需求！");
            return false;
        }
        if (!requiredMileage) {
            Toast.info("请输入线路所需里程！");
            return false;
        }
        if (!isRangeMeet) {
            Toast.info("请选择车辆续航里程是否满足您的业务需求！");
            return false;
        }
        if (value7.length == 0) {
            Toast.info("请选择车辆充电方式！");
            return false;
        }
        if (value7.includes("fast") && !charging.fast) {
            Toast.info("请输入快充时间！");
            return false;
        }
        if (value7.includes("slow") && !charging.slow) {
            Toast.info("请输入慢充时间！");
            return false;
        }
        if (getUrlParam("templateType") == "1") {
            if (!reason) {
                Toast.info("请输入您不想租赁的原因！");
                return false;
            }
        } else {
            if (!hopeRentNum) {
                Toast.info("请输入您希望租赁的车辆数！");
                return false;
            }
            if (!leaseTerm) {
                Toast.info("请输入您的意向租赁期限！");
                return false;
            }
            if (!recommend) {
                Toast.info("请输入您的建议！");
                return false;
            }
        }

        return getUrlParam("templateType") == "1"
            ? {
                  businessIndustryType,
                  businessIndustryName,
                  businessDeliveryFrequency,
                  isCargoCompartmentMeet,
                  businessMeet,
                  requiredMileage,
                  isRangeMeet,
                  reason,
                  fastCharging: charging.fast,
                  slowCharging: charging.slow,
              }
            : {
                  businessIndustryType,
                  businessIndustryName,
                  businessDeliveryFrequency,
                  isCargoCompartmentMeet,
                  businessMeet,
                  requiredMileage,
                  isRangeMeet,
                  fastCharging: charging.fast,
                  slowCharging: charging.slow,
                  hopeRentNum,
                  leaseTerm,
                  recommend,
              };
    };
    submit = () => {
        this.setState({ loading: true });
        const params = this.validate();
        if (!params) {
            this.setState({ loading: false });
            return;
        }
        post({
            url: api.addCarProbationFeedback,
            data: {
                rentalcode: getUrlParam("rentalcode"),
                templateType: getUrlParam("templateType"),
                ...params,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    //   Toast.info("提交成功", 1);
                    this.setState({ show: false, successStatus: true });
                }
                this.setState({ loading: false });
            },
            (res) => {
                Toast.info("提交失败", 5);
                this.setState({ loading: false });
            }
        );
    };

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    render() {
        const {
            show,
            successStatus,
            hasSubmit,
            Items,
            loading,
            businessIndustryType,
            businessIndustryName,
            businessDeliveryFrequency,
            isCargoCompartmentMeet,
            businessMeet,
            requiredMileage,
            isRangeMeet,
            value7,
            charging,
            reason,
            hopeRentNum,
            leaseTerm,
            recommend,
        } = this.state;

        return (
            <div className="VTFbox">
                <div className="top"></div>
                {hasSubmit ? (
                    <div className="success">
                        <div className="successLogo"></div>
                        <span className="successText">
                            反馈已提交，无需重复填写
                        </span>
                    </div>
                ) : (
                    ""
                )}
                {successStatus ? (
                    <div className="success">
                        <div className="successLogo"></div>
                        <span className="successText">
                            反馈已提交，感谢您的支持
                        </span>
                    </div>
                ) : (
                    ""
                )}
                {show ? (
                    <div className="tip">
                        <div className="topContent">尊敬的客户，您好！</div>
                        <div className="bottomContent">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;非常感谢您对远程慧联的选择与信任。为精准得到您对试用车的体验反馈，请您填写车辆试用意见，以便我们继续提升服务品质，为您提供更加优质的服务。再次感谢您的支持！
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {show ? (
                    <div className="content">
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                1.您的业务所属行业？
                            </p>
                            {Items.map((i) => (
                                <div
                                    key={i.value}
                                    className={
                                        businessIndustryType === i.value
                                            ? "list active"
                                            : "list"
                                    }
                                    // checked={value === i.value}
                                    onClick={() => this.onChange(i.value)}
                                >
                                    {i.label}
                                    {businessIndustryType === i.value ? (
                                        <Icon
                                            className="icon"
                                            type="check"
                                            size="sm"
                                        ></Icon>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ))}
                        </div>
                        {businessIndustryType == "5" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    1.1.您的所属行业是？
                                </p>
                                <div className="input">
                                    <TextareaItem
                                        placeholder="请输入"
                                        rows={4}
                                        count={70}
                                        value={businessIndustryName}
                                        onChange={(value) =>
                                            this.setState({
                                                businessIndustryName: value,
                                            })
                                        }
                                    ></TextareaItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                2.业务配送频次（次/天）
                            </p>
                            <div className="input">
                                <InputItem
                                    clear
                                    type="number"
                                    placeholder="请输入"
                                    value={businessDeliveryFrequency}
                                    onChange={(value) =>
                                        this.setState({
                                            businessDeliveryFrequency: value,
                                        })
                                    }
                                ></InputItem>
                            </div>
                        </div>
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                3.货箱是否满足您的业务需求？
                            </p>
                            {[
                                { label: "是", value: "1" },
                                { label: "否", value: "0" },
                            ].map((i) => (
                                <div
                                    key={i.value}
                                    className={
                                        isCargoCompartmentMeet === i.value
                                            ? "list active"
                                            : "list"
                                    }
                                    // checked={value === i.value}
                                    onClick={() => this.onChange1(i.value)}
                                >
                                    {i.label}
                                    {isCargoCompartmentMeet === i.value ? (
                                        <Icon
                                            className="icon"
                                            type="check"
                                            size="sm"
                                        ></Icon>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ))}
                        </div>
                        {isCargoCompartmentMeet == "0" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    3.1.您的货箱需求是？
                                </p>
                                <div className="input">
                                    <TextareaItem
                                        placeholder="请输入"
                                        rows={4}
                                        count={70}
                                        value={businessMeet}
                                        onChange={(value) =>
                                            this.setState({
                                                businessMeet: value,
                                            })
                                        }
                                    ></TextareaItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                4.线路所需里程（公里/天）
                            </p>
                            <div className="input">
                                <InputItem
                                    clear
                                    type="number"
                                    placeholder="请输入"
                                    value={requiredMileage}
                                    onChange={(value) =>
                                        this.setState({
                                            requiredMileage: value,
                                        })
                                    }
                                ></InputItem>
                            </div>
                        </div>
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                5.车辆续航里程是否满足您的业务需求？
                            </p>
                            {[
                                { label: "是", value: "1" },
                                { label: "否", value: "0" },
                            ].map((i) => (
                                <div
                                    key={i.value}
                                    className={
                                        isRangeMeet === i.value
                                            ? "list active"
                                            : "list"
                                    }
                                    // checked={value === i.value}
                                    onClick={() => this.onChange2(i.value)}
                                >
                                    {i.label}
                                    {isRangeMeet === i.value ? (
                                        <Icon
                                            className="icon"
                                            type="check"
                                            size="sm"
                                        ></Icon>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ))}
                        </div>
                        <div>
                            <p className="title">
                                <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                6.车辆充电方式？（多选）
                            </p>
                            {[
                                { label: "快充", value: "fast" },
                                { label: "慢充", value: "slow" },
                            ].map((i) => (
                                <div
                                    key={i.value}
                                    className={
                                        value7.includes(i.value)
                                            ? "list active"
                                            : "list"
                                    }
                                    // checked={value === i.value}
                                    onClick={() => this.onChange3(i.value)}
                                >
                                    {i.label}
                                    {value7.includes(i.value) ? (
                                        <Icon
                                            className="icon"
                                            type="check"
                                            size="sm"
                                        ></Icon>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ))}
                        </div>
                        {value7.map((ele, i) => {
                            return (
                                <div key={ele}>
                                    <p className="title">
                                        <span style={{ color: "#F56C6B" }}>
                                            *
                                        </span>{" "}
                                        6.{i + 1}.
                                        {ele == "fast" ? "快充" : "慢充"}
                                        时间是？（小时/天）
                                    </p>
                                    <div className="input">
                                        <InputItem
                                            type="number"
                                            clear
                                            placeholder="请输入"
                                            value={charging[ele]}
                                            onChange={(value) =>
                                                this.onChange4(value, ele)
                                            }
                                        ></InputItem>
                                    </div>
                                </div>
                            );
                        })}
                        {getUrlParam("templateType") == "1" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    7.您不想租赁的原因是什么呢？
                                </p>
                                <div className="input">
                                    <TextareaItem
                                        type="digit"
                                        placeholder="请输入"
                                        rows={6}
                                        count={150}
                                        value={reason}
                                        onChange={(value) =>
                                            this.setState({ reason: value })
                                        }
                                    ></TextareaItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {getUrlParam("templateType") == "2" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    7.您希望租赁的车辆数？（台）
                                </p>
                                <div className="input">
                                    <InputItem
                                        clear
                                        type="number"
                                        placeholder="请输入"
                                        value={hopeRentNum}
                                        onChange={(value) =>
                                            this.setState({
                                                hopeRentNum: value,
                                            })
                                        }
                                    ></InputItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {getUrlParam("templateType") == "2" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    8.您的意向租赁期限？（个月）
                                </p>
                                <div className="input">
                                    <InputItem
                                        clear
                                        type="number"
                                        placeholder="请输入"
                                        value={leaseTerm}
                                        onChange={(value) =>
                                            this.setState({ leaseTerm: value })
                                        }
                                    ></InputItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {getUrlParam("templateType") == "2" ? (
                            <div>
                                <p className="title">
                                    <span style={{ color: "#F56C6B" }}>*</span>{" "}
                                    9.其他建议
                                </p>
                                <div className="input">
                                    <TextareaItem
                                        type="digit"
                                        placeholder="请输入"
                                        rows={6}
                                        count={150}
                                        value={recommend}
                                        onChange={(value) =>
                                            this.setState({ recommend: value })
                                        }
                                    ></TextareaItem>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        <Button
                            className="button"
                            loading={loading}
                            onClick={() =>
                                alert(
                                    "确定提交意见反馈？",
                                    "提交后不可修改，请按实际情况填写",
                                    [
                                        {
                                            text: "取消",
                                            onPress: () =>
                                                console.log("cancel"),
                                        },
                                        {
                                            text: (
                                                <span
                                                    style={{ color: "#10C2B0" }}
                                                >
                                                    确定
                                                </span>
                                            ),
                                            onPress: () => {
                                                this.submit();
                                            },
                                        },
                                    ]
                                )
                            }
                        >
                            提交
                        </Button>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}
export default VehicleTrialFeedbackForm;



// WEBPACK FOOTER //
// ./src/vehicleTrialFeedbackForm/index/index.js